import {Widget} from "base/assets/js/widget/Widget.js";
import {Layers} from "base/assets/js/widget/Layers.js";
//import MediumEditor from "medium-editor";

export class Editor extends Widget {

	bMobile = 0;
	oEditor = null;
	sType = 'post';
	bNew = false;

	run() {
		//return;
		this._my( { mobile: 'b:bMobile', type: 's:sType', 'new': 'b:bNew' } );

		if( this._el( 'Body' ).innerHTML === '' ) {
			this._el( 'Body' ).innerHTML = '<p><br/></p>';
		}

		import( /* webpackChunkName: "editor" */ '../lib/MediumEditor.js' )
		.then( ( { MediumEditor, MediumEditorToolbar } ) => {

			const oWidget = this;

			// подмена вставки HTML
			const fnOriginCleanPaste = MediumEditor.extensions.paste.prototype.cleanPaste;
			MediumEditor.extensions.paste = MediumEditor.extensions.paste.extend( {
				cleanPastedHTML: true,
				cleanPaste: function( sHtml ) {
					oWidget.post(
						'/image/normalize',
						{ sHtml }
					).then( ( { sHtml } ) => {

							const fnLomRun = ( oEvent ) => {
								oWidget._link( oEvent.target );
								this.base.unsubscribe( 'editableInput', fnLomRun );
							}
							this.base.subscribe( 'editableInput', fnLomRun );
							MediumEditor.util.insertHTMLCommand( document, sHtml );
						}
					).catch( () => {
						fnOriginCleanPaste.call( this, sHtml );
					} )
				}
			} );


			// мобильная версия, с толковой версткой
			MediumEditor.extensions.toolbar = MediumEditor.extensions.toolbar.extend(
				MediumEditorToolbar
			);

			let aButtons;
			if( this.sType === 'post' ) {
				aButtons = [
					'undo',
					'h2',
					'bold',
					'italic',
					'strike',
					//'blockquote',
					'small',
					'anchor',
					'insert',
					'cut',
					'img' + ( this.bNew ? '-new' : '' ), // для новой версии отдельная кнопка
					'video',
					//'map',
					'remove'
				];
			} else {
				aButtons = [
					'undo',
					'h2',
					'bold',
					'italic',
					'strike',
					'small',
					'anchor',
					'insert',
					'img' + ( this.bNew ? '-new' : '' ), // для новой версии отдельная кнопка
					'video',
					//'map',
					'remove'
				];
			}

			if( this.bMobile && this.bNew ) {
				aButtons.push( 'br' );
			}

			this.oEditor = new MediumEditor(
				this._el( 'Body' ),
				{
					//disableReturn: true,
					toolbar: {
						allowMultiParagraphSelection: true,
						buttons: aButtons,
						diffLeft: 0,
						diffTop: -10,
						firstButtonClass: 'medium-editor-button-first',
						lastButtonClass: 'medium-editor-button-last',
						relativeContainer: this.bMobile ? document.body : null,
						standardizeSelectionStart: false,
						static: false,
						sticky: false,
						updateOnEmptySelection: false,
						bMobile: this.bMobile,
					},
					anchorPreview: {
						/* These are the default options for anchor preview,
						   if nothing is passed this is what it used */
						hideDelay: 500,
						previewValueSelector: 'a',
						showWhenToolbarIsVisible: true,
					},

					// превращаем google.com в ссылки
					autoLink :  true,

					// выключаем перетаскивание изображений
					imageDragging :  false,
					extensions: {
						'imageDragging': {},
						'placeholder': {},
					}
				}
			);

			this._updateTextarea();

			// нужно чтобы заработали карусели
			//this._link( this.oEditor.elements[ 0 ], false );

			this._on( '', 'insert-html', ( oEvent ) => {
				this.insertHtml( oEvent.detail.sHtml );
			} );

			// отдельное событие, например для системы сохранения черновиков
			this.oEditor.subscribe( 'editableInput', ( oEvent ) => {
				this._fire( '', 'textChange' );
				this._fire( oEvent.target, 'textChange' );
				this._updateTextarea();
			} );

			this.oEditor.subscribe( 'popupImg', () => {
				var wtype = $('._write').data('type');
				$.post('/image/getTemplate', {type:wtype}, (template) => {
					Write._imageUploadDialog( this.bl(), template);
				} );
			} );

			this.oEditor.subscribe( 'popupVideo', () => {
				if( this.bNew ) {

					// показываем специальный popup, и ждем из него resolve
					const oLayers = this._rel().typeOf( Layers ).find();
					oLayers.show( {
						sFrameId: 'popupInsertVideo',
						sLayer: "Popup",
						sUrl: '/image/popupInsertVideo',
						bPromise: true
					} )
						.then(
							( { oCustomData, iHideType } ) => {
								if( oCustomData && oCustomData.sHtml ) {
									this.oEditor.execAction( 'insert-html', {sHtml: oCustomData.sHtml} );
								}
							},
							::this.ajaxPopupCatch
						);
				} else {
					Write._videoLinkDialog( this.bl() );
				}
			} );

		} );
	}

	showAndUpdateToolbar() {
		if( !this.oEditor ) {
			return;
		}
		let oToolbar = this.oEditor.getExtensionByName( 'toolbar' );
		oToolbar.showAndUpdateToolbar();
	}

	insertHtml( sHtml ) {
		this.oEditor.execAction( 'insert-html', { sHtml } );
	}

	_updateTextarea() {
		// обновляем Textarea
		this._el( 'Textarea' ).value = this._el( 'Body' ).innerHTML.trim();
	}

	backupRange() {
		this.oEditor.backupRange();
	}
}